import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { OperationProvider } from '../providers/operation.provider';
import { ProductProvider } from '../providers/product.provider';
import { IdInterface, SelectedProductInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface UpdateOperationUseCaseParams {
    selectedProduct: SelectedProductInterface;
    clientCode?: IdInterface;
}

@Injectable()
export class UpdateOperationUseCase implements UseCaseWithParam<UpdateOperationUseCaseParams, Observable<Transaction<void>>> {
    constructor(private operationProvider: OperationProvider, private productProvider: ProductProvider) {}

    bind(params: UpdateOperationUseCaseParams): Observable<Transaction<void>> {
        return this.operationProvider.find().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (operation) =>
                        this.productProvider.detail(params.selectedProduct.encryptedCode).pipe(
                            switchMap((transactionProduct) =>
                                transactionProduct.map(
                                    (product) =>
                                        this.operationProvider.update(
                                            operation.contract,
                                            product,
                                            params.selectedProduct,
                                            operation.onlyRefund,
                                            operation.editing,
                                            operation.readonly,
                                            params.clientCode,
                                        ),
                                    (throwable) => of(Transaction.error(throwable.message))
                                )
                            )
                        ),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
